export const environment = {
  production: true,
  apiUrl: "https://rv-api.equinemedirecord.com/api/v1",
  socketUrl: "https://rv-api.equinemedirecord.com",
  socketPort: ":6001",
  maxImgCount: 5,
  maxImgSize: "20971520", // in bytes
  defaultLanguage: "aus",
  languages: [],
  country: "aus",
  availableCountries: {
    aus: "https://rv-app.equinemedirecord.com"
  },
  stripeKey: "pk_live_vbIkPJ9rozGCwgYaGZvwSjoS00WOM5lk7X",
  quick_treatment: false,
  currency: "USD",
  showRegionsSelect: true, //only for USA & UK
  ruleBookPdf: null,
  ruleBookKYPdf: null,
  ruleBookCAPdf: null,
  ruleBookBCPdf: null,
  ruleBookBCPdPopup: null,
  ruleBookBC2023Pdf: null,
  ruleBookBC2023PdfPopup: null,
  filterRegionForDrugs: false,
  showModalUnvaccinated: false,
  showInTheFoodChainToggle: false,
  dateFormat: "dd/MM/yyyy",
  disableTreatmentEditInstructorNotOwned: false, //If set to true instructor (trainer) can not edit treatments not created by him.
  currentCountry: "aus",
  vaccinationCountries: [],
  ruleBookPCPdf: "",
  ruleBookPCPopup: "",
  ruleBookPKPdf: "",
  ruleBookPKPdfPopup: "",
  vaccinationDocumentUrl: "",
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts